<template>
  <div>
    <v-row no-gutters>
      <v-col
        align-self="center"
        cols="10"
      >
        <v-card-title
          v-if="culture"
          class="px-2 secondary--text mx-2 mt-5 text-h6 text-md-subtitle-1 font-weight-bold"
        >
          {{ culture.typeCulture.nom | capitalize }}
        </v-card-title>
      </v-col>
      <v-col
        align-self="center"
        cols="1"
      >
        <AgrButton
          v-if="hasDroitEcriture && !hasClotureVerrouillee && ((culture.isDonneesVerifiees && isComplet) || isApv)"
          icon
          @click="onEditCulture"
        >
          <v-icon color="grey darken-2">
            mdi-pencil-outline
          </v-icon>
        </AgrButton>
        <v-tooltip
          v-if="(!hasDroitEcriture || hasClotureVerrouillee) && ((culture.isDonneesVerifiees && isComplet) || isApv)"
          bottom
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <AgrButton
                icon
              >
                <v-icon color="grey lighten-1">
                  mdi-pencil-outline
                </v-icon>
              </AgrButton>
            </div>
          </template>
          <span class="texte white--text">
            {{ hasClotureVerrouillee ? 'Coût de production réalisé. Modification impossible' : 'Vous n\'avez pas les autorisations' }}
          </span>
        </v-tooltip>
      </v-col>
      <v-col
        align-self="center"
        cols="1"
      >
        <AgrButton
          v-if="hasDroitEcriture && !hasClotureVerrouillee"
          icon
          @click="onDelete"
        >
          <v-icon color="grey darken-2">
            mdi-trash-can-outline
          </v-icon>
        </AgrButton>
        <v-tooltip
          v-else
          bottom
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <AgrButton
                icon
              >
                <v-icon color="grey lighten-1">
                  mdi-trash-can-outline
                </v-icon>
              </AgrButton>
            </div>
          </template>
          <span class="texte white--text">
            {{ hasClotureVerrouillee ? 'Coût de production réalisé. Modification impossible' : 'Vous n\'avez pas les autorisations' }}
          </span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row
      no-gutters
    >
      <v-col>
        <v-card-text class="intro texte-gris-fonce py-3">
          Surface
        </v-card-text>
      </v-col>
      <v-col>
        <v-card-text
          v-if="culture.surfaceEnHectare"
          :class="(culture.isDonneesVerifiees && !hasDonneeManquante) || isApv ? 'secondary--text' : '--text-orange-dark'"
          class="text-h6 py-2 align-end"
        >
          {{ culture.surfaceEnHectare | roundNumber(2) }}
          <span class="text-body-1">
            ha
          </span>
        </v-card-text>
        <div
          v-else
          :class="(culture.isDonneesVerifiees && !hasDonneeManquante) || isApv ? 'secondary--text' : '--text-orange-dark'"
          class="align-end py-2 pr-4 titre-h4"
        >
          -
        </div>
      </v-col>
    </v-row>
    <v-divider class="mx-4" />
    <v-row
      no-gutters
    >
      <v-col>
        <v-card-text class="intro texte-gris-fonce py-3">
          {{ libelleRendement }}
        </v-card-text>
      </v-col>
      <v-col>
        <v-card-text
          v-if="rendementCalcule"
          :class="(culture.isDonneesVerifiees && !hasDonneeManquante) || isApv ? 'secondary--text' : '--text-orange-dark'"
          class="text-h6 py-2 align-end"
        >
          {{ rendementCalcule | roundNumber(precisionRendement) }}
          <span class="text-body-1">
            {{ uniteRendement }}
          </span>
        </v-card-text>
        <v-col
          v-else
          :class="(culture.isDonneesVerifiees && !hasDonneeManquante) || isApv ? 'secondary--text' : '--text-orange-dark'"
          class="align-end py-2 pr-4 --text-orange-dark titre-h4"
        >
          -
        </v-col>
      </v-col>
    </v-row>
    <v-divider class="mx-4" />
    <v-row
      no-gutters
    >
      <v-col>
        <v-card-text class="intro texte-gris-fonce py-3 pl-4">
          {{ libellePoids }}
        </v-card-text>
      </v-col>
      <v-col>
        <v-card-text
          v-if="poidsCalcule"
          :class="(culture.isDonneesVerifiees && !hasDonneeManquante) || isApv ? 'secondary--text' : '--text-orange-dark'"
          class="text-h6 py-2 align-end"
        >
          {{ poidsCalcule | roundNumber(3) }}
          <span class="text-body-1">
            t
          </span>
        </v-card-text>
        <v-col
          v-else
          :class="(culture.isDonneesVerifiees && !hasDonneeManquante) || isApv ? 'secondary--text' : '--text-orange-dark'"
          class="align-end py-2 pr-4 --text-orange-dark titre-h4"
        >
          -
        </v-col>
      </v-col>
    </v-row>
    <v-divider
      v-if="isLinFibre"
      class="mx-4"
    />
    <v-row
      v-if="isLinFibre"
      no-gutters
    >
      <v-col>
        <v-card-text class="intro texte-gris-fonce py-3">
          Taux filasse
        </v-card-text>
      </v-col>
      <v-col>
        <v-card-text
          v-if="culture.tauxFilasseEnPourcentage"
          :class="(culture.isDonneesVerifiees && !hasDonneeManquante) || isApv ? 'secondary--text' : '--text-orange-dark'"
          class="text-h6 py-2 align-end"
        >
          {{ culture.tauxFilasseEnPourcentage| roundNumber(2) }}
          <span class="text-body-1">
            %
          </span>
        </v-card-text>
        <v-col
          v-else
          :class="(culture.isDonneesVerifiees && !hasDonneeManquante) || isApv ? 'secondary--text' : '--text-orange-dark'"
          class="align-end py-2 pr-4 titre-h4"
        >
          -
        </v-col>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      no-gutters
    >
      <BaseMessage
        v-if="hasMessageIncoherence"
        class="ma-2 align-center"
        color="secondary"
        message="Le rendement est incohérent pour cette graine."
        text
        type="info"
      />
    </v-row>
    <v-row
      v-if="isDonneesImporteAgrial"
      justify="center"
      no-gutters
    >
      <v-col class="ma-2 align-center">
        <span class="mention texte-gris-fonce">Données issues de l'import des données Agrial</span>
      </v-col>
    </v-row>
    <v-row
      v-if="!isApv"
      class="mb-12"
    />
    <v-row
      v-if="!isApv"
      class="mb-8"
    />
    <div
      v-if="!isApv"
      :class="isComplet && !culture.isDonneesVerifiees ? 'bottom-complet' : 'bottom'"
      class=" px-5 py-5 w-100"
    >
      <v-row v-if="isComplet && !culture.isDonneesVerifiees">
        <v-col cols="6">
          <AgrButton
            v-if="hasDroitEcriture && !hasClotureVerrouillee"
            :loading="loadingCulture"
            class="py-6 w-100"
            outlined
            @click="onEditCulture"
          >
            Modifier
          </AgrButton>
          <v-tooltip
            v-else
            bottom
          >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <AgrButton
                  :loading="loadingCulture"
                  class="py-6 w-100"
                  disabled
                  outlined
                >
                  Modifier
                </AgrButton>
              </div>
            </template>
            <span class="texte white--text">                    
              {{ hasClotureVerrouillee ? 'Coût de production réalisé. Modification impossible' : 'Vous n\'avez pas les autorisations' }}
            </span>
          </v-tooltip>
        </v-col>
        <v-col cols="6">
          <AgrButton
            v-if="hasDroitEcriture && !hasClotureVerrouillee"
            :loading="loadingCulture"
            class="py-6 w-100"
            @click="onConfirmerDonnees"
          >
            Confirmer
          </AgrButton>
          <v-tooltip
            v-else
            bottom
          >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <AgrButton
                  :loading="loadingCulture"
                  class="py-6 w-100"
                  disabled
                >
                  Confirmer
                </AgrButton>
              </div>
            </template>
            <span class="texte white--text">
              {{ hasClotureVerrouillee ? 'Coût de production réalisé. Modification impossible' : 'Vous n\'avez pas les autorisations' }}
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row
        v-else-if="!isComplet"
        class="d-flex bottom-12"
      >
        <v-col cols="12">
          <AgrButton
            v-if="hasDroitEcriture && !hasClotureVerrouillee"
            :loading="loadingCulture"
            class="py-6 w-100"
            @click="onEditCulture"
          >
            Compléter les données
          </AgrButton>
          <v-tooltip
            v-else
            bottom
          >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <AgrButton
                  :loading="loadingCulture"
                  class="py-6 w-100"
                  disabled
                  outlined
                >
                  Compléter les données
                </AgrButton>
              </div>
            </template>
            <span class="texte white--text">
              {{ hasClotureVerrouillee ? 'Coût de production réalisé. Modification impossible' : 'Vous n\'avez pas les autorisations' }}
            </span>
          </v-tooltip>
        </v-col>
      </v-row>

      <div
        v-else
        class="align-center"
      >
        <AgrButton
          :loading="loadingCulture"
          class="w-100 py-6"
          @click="onComparaisonsRendements"
        >
          <img
            alt="comp-icon"
            class="pr-2"
            src="@/assets/comparaison/icon-comparaison.svg"
          >
          Me comparer
        </AgrButton>
      </div>
    </div>
    <v-dialog
      v-model="dialogLeave"
      persistent
      width="500"
    >
      <ConfirmModal
        cancel-text="Non"
        confirm-text="Oui"
        title="Confirmation"
        @cancel="cancelConfirm"
        @confirm="deleteConfirm"
      >
        <p>Attention, vous souhaitez supprimer la graine. Si vous continuez, vos données liées à cette graine seront perdues.</p>
        <p>Voulez-vous vraiment continuer ?</p>
      </ConfirmModal>
    </v-dialog>

    <ComparaisonCulturesModal
      v-if="isOpenModalComparaison"
      :titre="culture.typeCulture.nom"
      :culture="culture"
      class="pa-3 background"
      :is-open-modal-comparaison="isOpenModalComparaison"
      @close="isOpenModalComparaison = false"
    />

    <InfoModal
      v-if="isOpenModaleInfosManquantes"
      confirm-text="Renseigner les infos"
      title="Infos manquantes"
      :is-open-modale-infos-manquantes="isOpenModaleInfosManquantes"
      @close="isOpenModaleInfosManquantes=false"
      @confirm="toCompte()"
    >
      <InfoManquanteContentModal />
    </InfoModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {clone} from '@/utils/clone'
import { convertirRendementCulture, isLinFibre, poidsFilasseEnTonne, precisionRendement, uniteRendement } from '@/utils/rendement'
import { AgrButton } from '@agrial/ui'
import BaseMessage from '@/components/common/base-message.vue'
import ComparaisonCulturesModal from './modal/comparaison-cultures-modal.vue'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import InfoManquanteContentModal from '@/components/modal/info-manquante-content-modal.vue'
import InfoModal from '@/components/modal/info-modal.vue'

export default {
  name: 'CultureRestitution',
  components: { AgrButton, BaseMessage, ComparaisonCulturesModal, ConfirmModal, InfoModal, InfoManquanteContentModal },
  props: {
    culture: {
      type: Object,
      default: () => { }
    },
    recolte: {
      type: Object,
      default: () => { }
    },
    anneeSelected: {
      type: String,
      default: null
    },
    isApv: {
      type: Boolean,
      default: false
    },
    hasClotureVerrouillee: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: {
        filtres: false,
        updateFiltres: false
      },
      erreur: {
        filtres: false,
        updateFiltres: false
      },
      dialogLeave: false,
      cultureModifiable: null,
      loadingCulture: false,
      poidsApporteEnTonne: null,
      isOpenModalComparaison: false,
      isOpenModaleInfosManquantes: false
    }
  },
  computed: {
    ...mapGetters({
      adherent: 'adherent/adherent',
      culturesSansMouvement: 'culture/culturesSansMouvement',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet'
    }),

    isLinFibre () {
      return isLinFibre(this.culture.typeCulture)
    },

    isComplet () {
      return !this.hasDonneeManquante
    },

    libelleRendement () {
      return this.isLinFibre ? 'Rendement filasse' : 'Rendement'
    },

    libellePoids () {
      return this.isLinFibre ? 'Poids total filasse' : 'Poids total'
    },

    hasDonneeManquante () {
      return !this.culture.rendementEnQuintauxParHectare || this.culture.rendementEnQuintauxParHectare === 0 ||
        !this.culture.surfaceEnHectare || this.culture.surfaceEnHectare === 0 ||
        !this.culture.poidsEnTonne || this.culture.poidsEnTonne === 0 ||
        (this.isLinFibre && (!this.culture.tauxFilasseEnPourcentage || this.culture.tauxFilasseEnPourcentage === 0))
    },
    poidsCalcule () {
      if (this.isLinFibre) {
        return poidsFilasseEnTonne(this.culture.poidsEnTonne, this.culture.tauxFilasseEnPourcentage)
      }

      return this.culture.poidsEnTonne
    },
    rendementCalcule () {
      return convertirRendementCulture(this.culture)
    },
    uniteRendement () {
      return uniteRendement(this.culture.typeCulture)
    },
    precisionRendement () {
      return precisionRendement(this.culture.typeCulture)
    },
    isDonneesImporteAgrial () {
      return this.culture?.isSurfaceImportee === true
    },
    hasMessageIncoherence () {
      if (this.culture.rendementEnQuintauxParHectare == null) {
        return false
      }
      const rendementMin = this.culture.typeCulture.rendementMinEnQuintauxParHectare || 0
      return this.culture.rendementEnQuintauxParHectare <= rendementMin || this.culture.rendementEnQuintauxParHectare > this.culture.typeCulture.rendementMaxEnQuintauxParHectare
    },
    hasDroitEcriture () {
      return this.$roles.hasCulturesWriteAccess()
    },
  },

  created () {
    this.getParametresExploitationComplet()
    this.initFiltres(this.adherent.codeRegion)
    this.getGrainesContractualiseesEtRecoltees(this.anneeSelected)
    this.loadResumeApport()
  },

  methods: {
    ...mapActions({
      getGrainesContractualiseesEtRecoltees: 'graine/getGrainesContractualiseesEtRecoltees',
      deleteCulture: 'culture/deleteCulture',
      createOrUpdateCulture: 'culture/createOrUpdateCulture',
      getPoidsGraineConseilleCulture: 'culture/getPoidsGraineConseilleCulture',
      initFiltres: 'filtresComparaison/initFiltres',
      setFiltres: 'filtresComparaison/setFiltres',
      getParametresExploitationComplet: 'parametresExploitation/getParametresExploitationComplet',
      updateCodeGraineActive: 'application/updateCodeGraineActive',
    }),

    loadResumeApport () {
      this.getPoidsGraineConseilleCulture({
        anneeRecolte: this.culture.anneeRecolte,
        codeTypeCulture: this.culture.typeCulture.code
      }).then((result) => {
        this.poidsApporteEnTonne = result.poidsApporteEnTonne
      }
      )
    },
    onDelete () {
      this.dialogLeave = true
    },
    cancelConfirm () {
      this.dialogLeave = false
    },
    deleteConfirm () {
      this.deleteCulture(this.culture)
        .catch(() => {
          this.serverError = true
        })
        .finally(() => {
          this.dialogLeave = false
        })
    },
    onEditCulture () {
      this.$emit('edit', this.culture)
    },
    onConfirmerDonnees () {
      this.loadingCulture = true
      this.cultureModifiable = clone(this.culture)
      this.cultureModifiable.isDonneesVerifiees = true
      this.createOrUpdateCulture(this.cultureModifiable)
        .catch(() => {
          this.serverError = true
        })
        .finally(() => {
          this.loadingCulture = false
        })
    },
    onComparaisonsRendements () {
      if (this.isParametresExploitationComplet) {
        this.isOpenModalComparaison = true
        const hasApport = !this.culturesSansMouvement.some(cultureSansMouvement => cultureSansMouvement.id === this.culture.id)
        const hasTypeCultureCorrespondanceRs3 = this.culture.typeCulture.graineRs3Correspondantes.length > 0

        let params = {
          anneeRecolte: this.culture.anneeRecolte,
          codeTypeCulture: this.culture.typeCulture.code
        }
        this.updateCodeGraineActive(this.culture.typeCulture.code)
        if (hasTypeCultureCorrespondanceRs3 && hasApport) {
          params.codeGraineRs3 = this.culture.typeCulture.graineRs3Correspondantes[0].code
        }
      } else {
        this.isOpenModaleInfosManquantes = true
      }
    },

    toCompte () {
      this.isOpenModaleInfosManquantes = false
      this.$router.push({ name: 'main.compte' })
    },

  }
}
</script>

<style lang="scss" scoped>
  .background {
    background: var(--gris);
  }
  .height-auto {
    height: 120px;
  }

  .align-end {
    text-align: end;
  }

  .align-center {
    text-align: center;
  }
  .bottom-complet {
    position: absolute;
    bottom: -16px;
  }

  .bottom {
    position: absolute;
    bottom: 0;
  }

  .bottom-12 {
    position: absolute;
    width: 96%;
    bottom: 5px;
  }
  .w-100 {
    width: 100%;
  }

</style>
